import axiosClient from 'api/axiosClient';
import LandownerElectricityPaymentHistoryView from 'features/ManageLandowner/components/LandownerElectricityPaymentHistoryView';
import AppTabs from 'general/components/AppTabs';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import CustomCard from 'general/components/Others/CustomCard';
import AppResource from 'general/constants/AppResource';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AgencyContractListView from 'features/Agency/components/AgencyContractListView';
import AppConstants from 'general/constants/AppConstants';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import AgencyHelper from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import ChargeStationCompactListView from 'features/Charge/ChargeStation/components/ChargeStationCompactListView';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import BuildInfoCardView from 'features/ManageDealer/components/BuildInfoCardView';
import PremiseListView from 'features/ManagePremises/components/PremiseListView';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import AgencyPremiseOrderListView from 'features/Agency/components/AgencyPremiseOrderListView';
import TransactionHistoryView from 'features/ManageDealer/components/TransactionHistoryView';
import { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import agencyCommissionApi from 'api/agencyCommissionApi';
import BankAccountsView from 'features/ManageDealer/components/BankAccountsView';
import agencyBankHelper from 'general/helpers/agencyBankHelper';
import EnergyBillListView from 'features/Charge/ChargeEnergyBill/components/EnergyBillListView';

LandownerDetailScreen.propTypes = {};

function LandownerDetailScreen(props) {
  // MARK: ---- params ----
  const { t } = useTranslation();
  const { isLandlordInfo = false } = props;
  const router = useRouter();
  const [filter, setFilter] = useState({});
  const { user, permissionList } = useSelector((state) => state.auth);
  const app = useSelector((state) => state.app);
  const agencyId = router.query?.landownerId;
  const [agencyDetail, setAgencyDetail] = useState();
  const [commission, setCommission] = useState('');
  const [commissionUnit, setCommissionUnit] = useState('');
  const [isAdminRole, setAdminRole] = useState(false);
  const agencyBank = agencyDetail?.bankAccounts?.length ? agencyDetail?.bankAccounts[0] : {};
  const isAgencyIndividual = useMemo(() => {
    return agencyDetail && agencyDetail?.type === AppConstants.accountType.individual;
  }, [agencyDetail]);

  const [parentAgencyDetail, setParentAgencyDetail] = useState();
  useEffect(() => {
    if (agencyDetail?.parentAgencyId) {
      AgencyHelper.API.requestAgencyDetail(agencyDetail?.parentAgencyId).then((data) => {
        setParentAgencyDetail(data);
      });
    }
  }, [agencyDetail]);

  useEffect(() => {
    if (
      user?.role === AppConstants.userRole.admin ||
      user?.role === AppConstants.userRole.operator
    ) {
      setAdminRole(true);
    }
  }, [user]);

  useEffect(() => {
    handleSetCommissionUnit(commission?.energyCommissionMode);
  }, [commission]);

  const handleSetCommissionUnit = (value) => {
    if (DealerHelper.checkPercentCommissionMode(value)) {
      setCommissionUnit('%');
    } else {
      setCommissionUnit('VNĐ');
    }
  };

  const areaTree = useSelector((state) => state.app.areaTree);
  const [agencyArea, setAgencyArea] = useState(null);
  const [agencyParentArea, setAgencyParentArea] = useState(null);
  useEffect(() => {
    if (areaTree && !_.isEmpty(areaTree) && agencyDetail) {
      const agencyAreaId = agencyDetail?.areaId;
      const agencyArea = ChargeHelper.Utils.getAreaById([areaTree], agencyAreaId);
      setAgencyArea(agencyArea);
      setAgencyParentArea(ChargeHelper.Utils.getAreaById([areaTree], agencyArea?.parentId));
    }
  }, [areaTree, agencyDetail]);

  // lay chi tiet AGENCY
  useEffect(() => {
    getAgencyDetail(agencyId);
  }, [agencyId, filter]);

  const getAgencyDetail = (id) => {
    DealerHelper.callApiGetAgencyDetail(id).then((data) => {
      if (data && Object.keys(data)?.length > 0) {
        setAgencyDetail(data);
      } else {
        router.navigate(-1);
      }
    });
  };

  useEffect(() => {
    const commission =
      agencyDetail?.commissions?.length > 0
        ? agencyDetail.commissions.find((item) => item?.role === 'LANDLORD')
        : [];
    setCommission(commission);
  }, [agencyDetail]);

  const hash = router?.location?.hash;
  const tabs = useMemo(() => {
    if (isAdminRole)
      return [
        t('Danh sách hợp đồng'),
        'Lịch sử cho thuê MB & mua hàng',
        'Danh sách mặt bằng',
        'Danh sách trạm sạc',
        'Lịch sử giao dịch',
        'Hóa đơn tiền điện',
        'Tài khoản ngân hàng'
      ].reverse();
    else if (!isAdminRole && !isLandlordInfo)
      return [
        t('Danh sách hợp đồng'),
        'Lịch sử cho thuê MB & mua hàng',
        'Danh sách mặt bằng',
        'Danh sách trạm sạc',
        'Tài khoản ngân hàng'
      ].reverse();
    else if (isLandlordInfo)
      return [
        t('Danh sách hợp đồng'),
        'Tài khoản ngân hàng',
      ].reverse();
  }, [isAdminRole, isLandlordInfo]);
  const [selectedTab, setSelectedTab] = useState(t('Danh sách hợp đồng'));
  useEffect(() => {
    if (hash === '#contract-list') setSelectedTab(t('Danh sách hợp đồng'));
    if (hash === '#premise-list') setSelectedTab(t('Danh sách mặt bằng'));
    if (hash === '#charge-stations') setSelectedTab('Danh sách trạm sạc');
    if (hash === '#premise-order') setSelectedTab('Lịch sử cho thuê MB & mua hàng');
    if (hash === '#transaction-history') setSelectedTab('Lịch sử giao dịch');
    if (hash === '#bank-accounts') setSelectedTab('Tài khoản ngân hàng');
    if (hash === '#electricity-bill') setSelectedTab('Hóa đơn tiền điện');
  }, [hash]);

  const contractListView = useMemo(() => {
    return <AgencyContractListView agencyId={agencyId} onRefresh={() => getAgencyDetail(agencyId)} ignoreCreateContractButton={true} />;
  }, [agencyId]);

  // danh sach mat bang
  const [premiseListFilter, setPremiseListFilter] = useState({
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    areaId: '',
    type: '',
    vehicleTypes: '',
    rentingType: '',
    rentalForm: '',
    status: '',
    contractStatus: '',
    landlordId: agencyId || '',
    free: '',
  });

  const premiseListEl = useMemo(() => {
    return (
      <PremiseListView
        showFullUI={false}
        agencyId={agencyId}
        premiseListFilter={premiseListFilter}
        onFilterChanged={(filter) => {
          setPremiseListFilter({
            ...premiseListFilter,
            ...filter,
          });
        }}
      />
    );
  }, [agencyId, premiseListFilter]);

  const premiseOrderListEl = useMemo(() => {
    return (
      <AgencyPremiseOrderListView
        showFullUI={false}
        agencyId={agencyId}
      />
    );
  }, [agencyId]);

  const [filterTransaction, setFilterTransaction] = useState({
    agencyId: agencyId,
    q: '',
    from: '',
    to: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: '',
    type: '',
    dateFilter: dateFilter.baMuoiNgayGanNhat,
  });
  const [transactionTotal, setTransactionTotal] = useState(0);
  const [transactionList, setTransactionList] = useState([]);

  useEffect(() => {
    if (isAdminRole) {
      handleGetTransactionList();
    }
  }, [filterTransaction, isAdminRole]);

  const handleGetTransactionList = async () => {
    const res = await agencyCommissionApi.getAgencyCommissionTransactions(filterTransaction);
    const { total, transactions } = res;
    setTransactionList(transactions);
    setTransactionTotal(total);
  };

  const transactionHistoryView = useMemo(() => {
    return (
      <TransactionHistoryView
        agencyRole='LANDLORD'
        agencyDetail={agencyDetail}
        transactionList={transactionList}
        transactionTotal={transactionTotal}
        filter={filterTransaction}
        onFilterChanged={(filter) => {
          setFilterTransaction({
            ...filterTransaction,
            ...filter,
          });
        }}
      />
    );
  }, [agencyDetail, transactionList, transactionTotal]);

  const energyBillView = useMemo(() => {
    return (
      <EnergyBillListView
        showFullUI={false}
        agencyId={agencyId}
      />
    );
  }, [agencyId]);

  const [agencyBankList, setAgencyBankList] = useState([]);

  useEffect(() => {
    if (isAdminRole || isLandlordInfo) {
      handleGetAgencyBankList();
    }
  }, [agencyId, isAdminRole, isLandlordInfo]);

  const handleGetAgencyBankList = async () => {
    const res = await agencyBankHelper.callApiGetAgencyBankList({ agencyId: agencyId });
    setAgencyBankList(res);
  };

  const bankAccountsView = useMemo(() => {
    return (
      <BankAccountsView
        agencyId={agencyId}
        agencyDetail={agencyDetail}
        banksList={agencyBankList}
        getAgencyBankList={handleGetAgencyBankList}
      />
    );
  }, [agencyId, agencyDetail, agencyBankList]);

  const [premiseList, setPremiseList] = useState([]);
  useEffect(() => {
    const params = {
      page: 0,
      limit: 5,
      landlordId: agencyId || '',
    };
    AgencyHelper.API.requestGetPremiseList(params)
      .then((response) => {
        setPremiseList(response?.premises);
      })
  }, [agencyDetail]);

  // MARK: ---- methods ----

  const handleGetRentingCost = (row) => {
    const landlordCommission = row?.landlord?.commissions?.find(
      (commission) => commission?.role === 'LANDLORD'
        && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
    );

    if (!row) return 'Không xác định';

    const hasMonthlyRent = row.monthlyRent > 0;
    const hasLandlordCommission = !!landlordCommission;

    if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chia sẻ doanh thu điện';
    if (hasMonthlyRent && (!hasLandlordCommission || landlordCommission?.energyCommissionValue === 0)) return 'Phí thuê cố định';
    if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Chi phí thuê kết hợp';

    return 'Phí thuê cố định';
  };

  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    if (newTab === 'Danh sách hợp đồng') {
      router.navigate('#contract-list');
    }
    if (newTab === 'Danh sách mặt bằng') {
      router.navigate('#premise-list');
    }
    if (newTab === 'Danh sách trạm sạc') {
      router.navigate('#charge-stations');
    }
    if (newTab === 'Hóa đơn tiền điện') {
      router.navigate('#electricity-bill');
    }
    if (newTab === 'Lịch sử giao dịch') {
      router.navigate('#transaction-history');
    }
    if (newTab === 'Tài khoản ngân hàng') {
      router.navigate('#bank-accounts');
    }
    if (newTab === 'Lịch sử cho thuê MB & mua hàng') {
      router.navigate('#premise-order');
    }
    setSelectedTab(newTab);
  };

  const AgencyInfo = () => {
    return (
      <div
        className="row m-0 position-relative p-3 bg-white rounded-lg"
        style={{
          border: `1px solid ${AppColors.gray[300]}`,
          boxShadow: '0px 7px 8px -3px #0000000D',
        }}
      >
        <div className="d-flex px-0 align-items-start w-100">
          <div className="d-flex align-items-center w-95">
            <img
              className="rounded-circle"
              src={
                agencyDetail?.avatar
                  ? Utils.getFullUrl(agencyDetail?.avatar)
                  : AppResource.icons.avatar.default
              }
              style={{
                width: 44,
              }}
            />
            <div className="d-flex flex-column ml-3 w-100">
              <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                <div
                  // className="font-weight-bolder text-ellipsis-2-lines"
                  style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                >
                  {agencyDetail?.name}
                </div>

                <span className="min-w-100px pt-1">
                  <KTLabel
                    text={t(`agencyStatus_${agencyDetail?.status}`)}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(
                      agencyDetail?.status
                    )}`}
                  />
                </span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    color: AppColors.gray[700],
                    fontSize: Utils.returnFontSize(14),
                    fontWeight: 400,
                  }}
                >
                  {t('Số dư ví:')}
                </div>
                <span
                  style={{
                    color: AppColors.gray[800],
                    fontSize: Utils.returnFontSize(13),
                    fontWeight: 600,
                  }}
                >
                  {Utils.formatNumber(agencyDetail?.balance)} VNĐ
                </span>
              </div>
            </div>
          </div>

          <div className="d-flex gap-3 justify-content-end ml-auto">
            <VITableRowDropDown
              toggleElement={
                <a
                  href="#"
                  className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                  style={{ backgroundColor: AppColors.gray[200] }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <i
                    className="fa-solid fa-ellipsis"
                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                  />
                </a>
              }
              menuItem={[
                {
                  iconElement: <i className={`fa-regular fa-bolt`}></i>,
                  text: t('Kích hoạt tài khoản'),
                  click: () => {
                    DealerHelper.handleAcceptAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show: agencyDetail?.status === 'REGISTERED'
                    && (isAdminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.landlordUpdate.code),
                },
                {
                  iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                  text: t('edit'),
                  click: () => {
                    BreadcrumbHelper.setBreadcrumPath(
                      `Chỉnh sửa chủ mặt bằng`,
                      `${router?.pathname}/edit`
                    );
                    router.navigate('edit');
                  },
                  show: (!agencyDetail?.numberOfSignedContracts
                    && DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    )
                    || isAdminRole)
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.landlordUpdate.code),
                },
                {
                  iconElement: <i className="far fa-square"></i>,
                  text: t('Ngừng hoạt động'),
                  click: () => {
                    DealerHelper.handleStopAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status === 'NORMAL'
                    && (isAdminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isLandlordInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.landlordUpdate.code),
                },
                {
                  iconElement: <i className="far fa-play"></i>,
                  text: t('Khôi phục hoạt động'),
                  click: () => {
                    DealerHelper.handleActiveAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status === 'SUSPENDED'
                    && (isAdminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isLandlordInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.landlordUpdate.code),
                },
                {
                  iconElement: <i className={`fa-regular fa-lock`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                  text: t('Đặt lại mật khẩu'),
                  click: () => {
                    DealerHelper.showDialogChangePassword(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    })
                  },
                  show: isAdminRole && Utils.checkPermission(permissionList, AppConstants.permissionCode.landlordUpdate.code),
                },
                {
                  iconElement: <i className={`fa-regular fa-trash-can`}></i>,
                  text: t('Xóa chủ mặt bằng'),
                  click: () => {
                    DealerHelper.handleDeleteAgency(agencyDetail, () => {
                      router.navigate(-1);
                    });
                  },
                  show: !agencyDetail?.numberOfSignedContracts
                    && (isAdminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isLandlordInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.landlordDelete.code),
                },
              ]}
              singleBtnBgColor={AppColors.gray[200]}
            />
          </div>
        </div>

        <div
          className="my-4"
          style={{
            borderTop: `1px dashed ${AppColors.gray[300]}`,
          }}
        />

        {/* thong tin CMB */}
        <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
          <div className=" d-flex flex-lg-row flex-column flex-wrap">
            <>
              <div className="col-xl-6 p-0 pr-xl-3 pl-0 my-1 d-flex flex-column gap-3">
                {AgencyUIHelper.buildAccountInfoCard(agencyDetail, parentAgencyDetail, isAgencyIndividual, "LANDLORD")}

                {/* 'Thông tin định danh eKYC' */}
                {AgencyUIHelper.buildEKYCInfoCard(agencyDetail)}

                {isAgencyIndividual && AgencyUIHelper.buildHsmAgreementCard(agencyDetail)}
              </div>

              <div className="col-xl-6 p-0 pl-0 my-1 d-flex flex-column gap-3">
                {AgencyUIHelper.buildOtherInfoCard(agencyDetail, agencyParentArea, agencyArea, agencyBank, isAgencyIndividual, isAdminRole, isLandlordInfo)}

                {AgencyUIHelper.buildDocumentInfoCard(agencyDetail, isAgencyIndividual)}

                {!isAgencyIndividual && AgencyUIHelper.buildHsmAgreementCard(agencyDetail)}
              </div>
            </>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="w-100">
        {!isLandlordInfo && BreadcrumbHelper.buildBreadcrumb([
          {
            title: `Danh sách chủ mặt bằng`,
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết chủ mặt bằng' },
        ])}
      </div>

      <div className={`m-4 ${!isLandlordInfo ? 'mt-16' : ''}`}>
        {/* thong tin Chu dat */}
        <CustomCard
          showHeader={false}
          additionalClassName="rounded-lg overflow-hidden"
          bgTransparent={true}
          showBorder={false}
          body={
            <div className="d-xl-flex d-lg-flex">
              {/* thong tin Chu dat */}
              <AgencyInfo />

              <div className="d-flex flex-column col-xl-3 row col-md-12 m-0 pl-lg-4 pl-0 pr-0 mb-sm-5 mb-lg-0 mt-5 mt-lg-0">
                <BuildInfoCardView
                  type="table"
                  bgIconColor="#2984EE"
                  icon={<i className="fas fa-house-chimney-user fa-2x text-white" />}
                  name="Phí thuê mặt bằng"
                  defaultText="Phí thuê áp dụng cho mỗi loại mặt bằng"
                  textHeader={['Mã mặt bằng', 'Cách tính']}
                  contents={premiseList?.map(premise => ({
                    name: `<div 
                            style="font-weight: 600; color: #30BD6F; cursor: pointer;" 
                            onclick="window.open('${AppRoute.premisesList}/${premise?.premiseId || 'Không xác định'}', '_blank')"
                          >${premise?.premiseId}</div>`,
                    value: `<div 
                            style="font-weight: 500; color: #494968; cursor: pointer;" 
                          >${handleGetRentingCost(premise)}</div>`
                  }))}
                  additionalButton={(
                    <div>
                      {UIHelper.buildNegativeButton('Xem danh sách mặt bằng', () => {
                        if (isAdminRole) {
                          handleSelectedTab('Danh sách mặt bằng')
                        } else {
                          Utils.openInNewTab(`${AppRoute.premisesList}`)
                        }
                      })}
                    </div>
                  )}
                />
              </div>
            </div>
          }
        />

        {/* table */}
        <>
          <div className="pt-0">
            <AppTabs
              tabs={tabs}
              activeTab={selectedTab}
              handleClick={handleSelectedTab}
              className="mt-3 mr-3"
              additionalClassName=""
            />
            <div
              className="bg-white shadow"
              style={{
                borderLeft: `1px solid ${AppColors.gray[300]}`,
                borderRight: `1px solid ${AppColors.gray[300]}`,
                borderBottom: `1px solid ${AppColors.gray[300]}`,
                borderRadius: '0px 10px 10px 10px',
              }}
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={selectedTab}
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -10, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  {selectedTab == t('Danh sách hợp đồng') && (
                    <div className="py-4">{contractListView}</div>
                  )}
                  {selectedTab == t('Danh sách mặt bằng') && (
                    <div className="pb-3 pt-4">{premiseListEl}</div>
                  )}
                  {selectedTab == t('Lịch sử cho thuê MB & mua hàng') && (
                    <div className="pb-3 pt-4">{premiseOrderListEl}</div>
                  )}
                  {selectedTab == 'Lịch sử giao dịch' && (
                    <div className="px-5 pb-3 pt-4">{transactionHistoryView}</div>
                  )}
                  {selectedTab == 'Hóa đơn tiền điện' && (
                    <div className="pb-3 pt-4">{energyBillView}</div>
                  )}
                  {selectedTab == 'Tài khoản ngân hàng' && <div>{bankAccountsView}</div>}
                  {selectedTab == 'Danh sách trạm sạc' && (
                    <div>
                      <ChargeStationCompactListView
                        hasAppTab={true}
                        initialFilter={{
                          landlordId: agencyId,
                        }}
                      />
                    </div>
                  )}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default LandownerDetailScreen;
